module.exports = __webpack_public_path__ + "img/Electricite_de_Strasbourg_120X35.7f6612c5.png";